import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_bulk_change_walking_female~1
			funnel: {
				id: 'ob-female-walking-bulk-change-i2',
				locale: ['en'],
			},
			landing: {
				experiment: () =>
					import(
						/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_bulk_change_walking_female'
					),
			},
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_bulk_change_walking_female'
					),
			},
		},
	},
]

export default config
